module.exports = __webpack_public_path__ + "img/snacks.97ccdc12.jpg";